import React from 'react';
import '../styles/Word.css';

function Word({ word, guessedLetters }) {
  if (!word) return null;
  
  return (
    <div className="word-container">
      {word.split('').map((letter, index) => (
        <span key={index} className="letter-container">
          {letter === ' ' ? (
            <span className="space"></span>
          ) : (
            <span className={`letter ${guessedLetters.includes(letter) ? 'visible' : 'hidden'}`}>
              {guessedLetters.includes(letter) ? letter : '_'}
            </span>
          )}
        </span>
      ))}
    </div>
  );
}

export default Word; 